import { EventObject } from '@xstate/store-react';
import { AppRoute } from '../../../enums/appRoutes';
import { StoreContext } from '../../../models/store/context';
import { ApplianceModel } from '../../../models/services/api/queryModelNumber';
import { log } from '@domgen/shared/utils/log';
import { StoreEvent } from '../../../enums/storeEvent';

export const saveModelLookupResult = <T extends EventObject = EventObject>(
  context: StoreContext,
  event: T & { data: ApplianceModel[] },
  _enqueue: {
    effect: (effect: () => Promise<void>) => void;
    emit: { navigate: (payload: { path: AppRoute; replace?: boolean }) => void };
  },
): StoreContext => {
  log.debug({ message: StoreEvent.SAVE_APPLIANCE_MODEL_RESULTS, data: event.data });
  return {
    ...context,
    applianceLookupResults: [...event.data],
  };
};
